(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NewsEditController', NewsEditController);

    NewsEditController.$inject = ['NewsService', '$state', '$q'];

    function NewsEditController(NewsService, $state, $q) {
        var vm = this;

        vm.news = {
            language: 'de_DE',
            title: '',
            teaser: '',
            content: '',
            image: null,
            downloads: [],
        };
        vm.imageUploadStatus = null;
        vm.imagePreviewThumbnail = null;

        vm.submit = submit;
        vm.uploadImage = uploadImage;
        vm.uploadAttachment = uploadAttachment;
        vm.removeAttachment = removeAttachment;

        function submit() {
            NewsService.create(vm.news).then(function () {
                $state.go('news');
            }, function (error) {
                // Ignore unhandled error
                return $q.reject(error);
            });
        }

        function uploadImage(file) {
            if (!file) {
                return;
            }

            vm.imageUploadStatus = 0;
            NewsService.uploadImage(file, vm.news.image).then(function (data) {
                vm.news.image = data.fileName;
                vm.imagePreviewThumbnail = data.fileDownloadUri;
                vm.imageUploadStatus = null;
            }, function () {
                vm.imageUploadStatus = null;
            }, function (event) {
                vm.imageUploadStatus = parseInt(100.0 * event.loaded / event.total);
            });
        }

        function uploadAttachment(file) {
            if (!file) {
                return;
            }

            NewsService.uploadAttachment(file).then(function (data) {
                vm.news.downloads.push({
                    uuid: data.fileName,
                    title: file.name.split('.').slice(0, -1).join('.')
                });
            }, function () {
            }, function (event) {
            });
        }

        function removeAttachment(uuid) {
            NewsService.removeAttachment(uuid);
            vm.news.downloads = vm.news.downloads.filter(function (download) {
                return download.uuid !== uuid;
            });
        }
    }
})();
